const InvoiceNotesTabStyles = {
  container: {
    p: 3
  },
  
  card: {
    p: 4, 
    borderRadius: '16px', 
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e5e7eb'
  },
  
  mainTitle: {
    fontSize: '1.5rem',
    fontWeight: 700,
    mb: 3,
    color: '#1976d2',
    display: 'flex',
    alignItems: 'center',
    gap: 1.5
  },
  
  textField: {
    '& .MuiInputBase-input': { 
      padding: '16px',
      verticalAlign: 'top',
      fontSize: '0.95rem'
    },
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      transition: 'all 0.3s ease',
      '& fieldset': {
        borderColor: '#e5e7eb',
        borderWidth: '2px'
      },
      '&:hover fieldset': {
        borderColor: '#9ca3af'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#1976d2',
        borderWidth: '2px',
        boxShadow: '0 0 0 4px rgba(25, 118, 210, 0.1)'
      }
    },
    '& .MuiInputBase-inputMultiline': {
      alignItems: 'flex-start'
    },
    '& .MuiInputLabel-root': {
      transform: 'translate(14px, 16px) scale(1)'
    },
    '& .MuiInputBase-root': {
      alignItems: 'flex-start'
    }
  },
  
  buttonsContainer: {
    display: 'flex', 
    justifyContent: 'flex-end',
    mt: 2.5
  },
  
  previousNotesHeader: {
    display: 'flex',
    alignItems: 'center',
    mb: 2,
    p: 2,
    borderRadius: '12px',
    backgroundColor: 'rgba(25, 118, 210, 0.04)',
    border: '1px solid rgba(25, 118, 210, 0.1)'
  },
  
  noteCountChip: {
    ml: 1.5,
    height: '24px',
    fontWeight: 700,
    fontSize: '0.813rem',
    boxShadow: '0 2px 6px rgba(25, 118, 210, 0.2)'
  },
  
  previousNotesContainer: {
    mb: 3,
    maxHeight: '400px',
    overflowY: 'auto',
    borderRadius: '12px',
    backgroundColor: '#ffffff',
    boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.04)',
    '&::-webkit-scrollbar': {
      width: '8px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f1f1f1',
      borderRadius: '4px'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#1976d2',
      borderRadius: '4px',
      '&:hover': {
        backgroundColor: '#1565c0'
      }
    }
  },
  
  previousNoteItem: {
    py: 2,
    px: 2.5,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      backgroundColor: 'rgba(25, 118, 210, 0.02)'
    }
  },
  
  noteWrapper: {
    width: '100%'
  },
  
  noteHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    mb: 1.5
  },
  
  userInfoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5
  },
  
  userAvatar: {
    width: 36,
    height: 36,
    fontSize: '0.875rem',
    fontWeight: 600,
    bgcolor: 'primary.main',
    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)'
  },
  
  noteText: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    color: '#374151',
    pl: 5,
    fontSize: '0.95rem',
    lineHeight: 1.6
  },
  
  noteUser: {
    fontWeight: 600,
    color: '#1f2937',
    fontSize: '0.95rem'
  },
  
  noteDate: {
    color: '#9ca3af',
    fontSize: '0.813rem',
    fontWeight: 500
  },
  
  noteContent: {
    pl: 0.5
  },
  
  newNotesLabel: {
    mt: 2,
    mb: 2,
    fontSize: '1.1rem',
    fontWeight: 600
  },
  
  sectionDivider: {
    my: 4,
    borderColor: '#e5e7eb',
    borderWidth: '1px'
  },
  
  addNoteSection: {
    mt: 2
  },
  
  newNoteContainer: {
    p: 3,
    borderRadius: '12px',
    backgroundColor: '#f8f9fa',
    border: '1px solid #e5e7eb',
    boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
  },
  
  saveButton: {
    minWidth: '180px',
    borderRadius: '10px',
    px: 4,
    py: 1.5,
    fontWeight: 600,
    fontSize: '1rem',
    textTransform: 'none',
    background: 'linear-gradient(135deg, #1976d2 0%, #0d47a1 100%)',
    boxShadow: '0 3px 12px rgba(25, 118, 210, 0.35)',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '-100%',
      width: '100%',
      height: '100%',
      background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.25), transparent)',
      transition: 'left 0.5s ease'
    },
    '&:hover': {
      background: 'linear-gradient(135deg, #1565c0 0%, #0c3d8a 100%)',
      boxShadow: '0 6px 20px rgba(25, 118, 210, 0.45)',
      transform: 'translateY(-2px)',
      '&::before': {
        left: '100%'
      }
    },
    '&:active': {
      transform: 'translateY(0px)'
    },
    '&.Mui-disabled': {
      background: '#e0e0e0',
      color: '#9e9e9e',
      boxShadow: 'none'
    }
  },

  attachmentButton: {
    borderRadius: '10px',
    borderColor: '#d1d5db',
    borderWidth: '2px',
    fontWeight: 600,
    textTransform: 'none',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderWidth: '2px',
      borderColor: '#1976d2',
      backgroundColor: 'rgba(25, 118, 210, 0.04)'
    }
  },

  attachmentBox: {
    mt: 2.5,
    p: 2.5,
    border: '2px dashed #d1d5db',
    borderRadius: '12px',
    backgroundColor: '#fafafa',
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: '#1976d2',
      backgroundColor: '#f8f9fa'
    }
  },

  fileItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    p: 1.5,
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    mb: 1,
    backgroundColor: 'white',
    transition: 'all 0.2s ease',
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
      borderColor: '#9ca3af'
    }
  },

  attachmentChip: {
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    backgroundColor: 'rgba(25, 118, 210, 0.08)',
    borderColor: 'primary.main',
    borderWidth: '2px',
    fontWeight: 500,
    '&:hover': {
      backgroundColor: 'primary.main',
      color: 'white',
      transform: 'translateY(-2px)',
      boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
      '& .MuiChip-icon': { 
        color: 'white' 
      }
    }
  }
};

export default InvoiceNotesTabStyles;